if (!customElements.get("page-navigator")) {
  class ComponentPageNavigator extends HTMLElement {
    constructor() {
        super();
        this.navigationItemsEl = this.querySelector('.mobile-nav .navigation-items');
        this.itemsPerViewTablet = this.dataset.itemsPerViewTablet ? parseFloat(this.dataset.itemsPerViewTablet) : 1;
        this.itemsPerViewMobile = this.dataset.itemsPerViewMobile ? parseFloat(this.dataset.itemsPerViewMobile) : 1;
        this.itemsSpacing = this.dataset.itemsSpacing ? parseInt(this.dataset.itemsSpacing) : 10;
        this.initSlider()
        this.initLinks()
    }
    initLinks() {
        let linksEl = this.querySelectorAll('[data-link]');
        linksEl.forEach(linkEl => linkEl.addEventListener('click', this.onLinkClick.bind(this)))
    }
    onLinkClick(event) {
        event.preventDefault();
        let $gs = $s || window.$s;
        if (!$gs) return;
        $gs.scrollToElement(document.getElementById(event.currentTarget.dataset.link))
    }
    initSlider() {
        let breakpoints = {};
        breakpoints['(max-width: '+window.breakpoints.small+')'] = {
            slidesPerView: this.itemsPerViewMobile
        }
        this.carousel = new KeenSlider(this.navigationItemsEl, {
          mode: "snap",
          loop: true,
          wheel: false,
          slidesPerView: this.itemsPerViewTablet,
          spacing: this.itemsSpacing,
          centered: false,
          breakpoints
        });
    }
  }
  customElements.define("page-navigator", ComponentPageNavigator);
}
